import React, { useState } from 'react'
import logo from '../../assets/logo.png'
import Bars from '../../assets/bars.png'
import './Header.css'
import { Link } from 'react-scroll'

export const Header = () => {
  const mobile = window.innerWidth<=768?true:false;
  const[menuOpened,setMenu]=useState(false);
  return (
    <div className='hero-header' id='hero'>
        <img src={logo} alt="logo" className="logo" />
        {
          (menuOpened===false && mobile === true)?(
            <div style={{backgroundColor:'var(--appColor)', padding:"0.5rem",borderRadius:"5px"}} 
            onClick={()=>{
              setMenu(true)
            }}>
              <img src={Bars} alt="" style={{width:"1.5rem", height:"1.5rem"}} />
            </div>
          ):( <ul className="header-menu">
            <li  ><Link 
            onClick={()=>{setMenu(false)}}
            to='hero'
            >Home</Link></li>
            <li ><Link
            to='programs' 
            smooth={true}
            span={true}
            activeClass='active'
            onClick={()=>{setMenu(false)}}
            >Programs</Link></li>
            <li ><Link
            to='reasons'
            smooth={true}
            span={true}
            onClick={()=>{setMenu(false)}}
            >
            why us
            </Link></li>
            <li > 
              <Link 
              to='plans'
              smooth={true}
            span={true}
            onClick={()=>{setMenu(false)}}
              >
              Plans
              </Link>
            </li>
            <li ><Link 
            to='testimonial'
            smooth={true}
            span={true}
            onClick={()=>{setMenu(false)}}>Testimonials</Link></li>
        </ul>)
        }
    </div>
  )
}
